import { useSyncExternalStore } from 'react';

type useMediaQueryReturn<T> = T extends number ? [boolean, number] : [number];

/**
 * Module-level store for viewport width.
 * Shared across all hook instances — a single resize listener
 * updates the value for every consumer.
 */
let currentWidth = 0;
const listeners: Set<() => void> = new Set();

function notifyListeners(): void {
  const newWidth = window.innerWidth;
  if (newWidth !== currentWidth) {
    currentWidth = newWidth;
    listeners.forEach((listener) => listener());
  }
}

// Initialize on first client load (runs once at module import time, before any component mounts)
if (typeof window !== 'undefined') {
  currentWidth = window.innerWidth;
  window.addEventListener('resize', notifyListeners);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): number {
  return currentWidth;
}

function getServerSnapshot(): number {
  return 0;
}

//custom hook that returns if current screen width is larger than
//the width breakpoint argument or not
const useMediaQuery = <T>(breakpoint?: T) => {
  const width = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  return (breakpoint != null ? [width >= +breakpoint, width] : [width]) as useMediaQueryReturn<T>;
};

export default useMediaQuery;
